import $ from 'jquery';
import axios from 'axios';
import toastr from 'toastr';
import { loader } from './../layout/loader'
import { datatablesArr } from './../components/datatables';
import { refreshTable } from './../components/datatables-helpers';
import Translator from 'bazinga-translator';

let popup;

function refreshDatatable() {

    refreshTable(datatablesArr['app_estimation_setting_row_list']);

    $('#listing_table_app_estimation_setting_row_list').find('.table__empty--nodata').removeClass('is-active');

}

function discountIsActive(input) {
    if (input == true) {
        return 'checked'
    }
}

class Popup {
    body: Object;
    element: Object;
    options: Object;
    templateOverlay: string;
    templatePopup: string;

    constructor(element: Object) {
        this.body = $('body');
        this.element = element;
        this.options = element.data('options');
        this.templateOverlay = '';
        this.templatePopup = '<div class="pop-up -esti-settings -sm"><div class="pop-up__background js-popup-close"></div></div>';
    }

    removePopupHtml() {
        $('.pop-up').remove();

        popup = null;
    }

    hidePopup() {
        $('.pop-up').removeClass('is-opened');
        setTimeout(() => {
            $('.overlay').removeClass('is-active');
        }, 300);

        setTimeout(() => {
            this.removePopupHtml();
        }, 500);
    }

    showPopup() {
        $('.overlay').addClass('is-opened');
        setTimeout(() => {
            $('.pop-up').addClass('is-opened');
        }, 200);
    }

    fetchContent() {

        $('.pop-up').append(

            '<div class="pop-up__box">' +
            '<form>' +

            '<div class="pop-up__content">' +
            '<h2>' + Translator.trans('edit_mode.modal.row.create_new_header', [], 'app') + '</h2>' +

            '<label for="template_name">' + Translator.trans('edit_mode.modal.row.template_name', [], 'app') + '</label>' +
            '<div class="input"><input type="text" id="template_name" placeholder="' + Translator.trans('edit_mode.modal.row.template_name_placeholder', [], 'app') + '" value=""></div>' +

            '<label for="title">' + Translator.trans('edit_mode.tool_panel.row.title', [], 'app') + '</label>' +
            '<div class="input"><input type="text" id="title" placeholder="' + Translator.trans('edit_mode.tool_panel.row.title_placeholder', [], 'app') + '" value=""></div>' +

            '<label for="subtitle">' + Translator.trans('edit_mode.tool_panel.row.subtitle', [], 'app') + '</label>' +
            '<div class="input"><input type="text" id="subtitle" placeholder="' + Translator.trans('edit_mode.tool_panel.row.subtitle_placeholder', [], 'app') + '" value=""></div>' +

            '<div class="box-form__row -half">' +
                '<div class="input">' +
                    '<label for="rate_value">' + Translator.trans('edit_mode.tool_panel.row.amount', [], 'app') + '</label>' +
                    '<div class="input__field"><input type="text" id="rate_value" placeholder="' + Translator.trans('edit_mode.tool_panel.row.amount_placeholder', [], 'app') + '" value=""></div>' +
                '</div>' +
                '<div class="input">' +
                    '<label for="rate_unit">' + Translator.trans('edit_mode.tool_panel.row.unit', [], 'app') + '</label>' +
                    '<div class="input__field"><input type="text" id="rate_unit" placeholder="' + Translator.trans('edit_mode.tool_panel.row.unit_placeholder', [], 'app') + '" value=""></div>' +
                '</div>' +
            '</div>' +
            '<div class="box-form__row -half">' +
                '<div class="input">' +
                    '<label for="rate_currency">' + Translator.trans('edit_mode.tool_panel.row.currency', [], 'app') + '</label>' +
                    '<div class="input__field"><input type="text" id="rate_currency" placeholder="' + Translator.trans('edit_mode.tool_panel.row.currency_placeholder', [], 'app') + '" value=""></div>' +
                '</div>' +
                '<div class="input box-form__input--discount">' +
                    '<label for="discount">' + Translator.trans('edit_mode.tool_panel.row.row_discount', [], 'app') + '</label>' +
                    '<div class="input__field"><input type="text" id="discount" value=""></div>' +
                    '<label class="flipswitch" title="Ustaw widoczność strony"><input id="active_discount" type="checkbox" class="flipswitch__check" />' +
                    '<div class="flipswitch__switch">' +
                    '<div class="flipswitch__switch-button"></div>' +
                    '</div>' +
                    '<div class="flipswitch__msg">' +
                    '<span class="flipswitch__msg__on">ON</span>' +
                    '<span class="flipswitch__msg__off">OFF</span></div>' +
                    '</label>' +
                '</div>' +
            '</div>' +
            '</div>' +

            '<div class="pop-up__buttons">' +
            '<a class="btn-popup js-popup-close" href="#">' + Translator.trans('cancel', [], 'app') + '</a>' +
            '<button class="btn-popup -primary js-popup-settings-save" type="submit">' + Translator.trans('save', [], 'app') + '</button>' +
            '</div>' +
            '</form>' +
            '</div>'
        );

        $('.js-popup-settings-save').on('click', function(e) {
            e.preventDefault();
            popup.addNew();
        });

        this.showPopup();

    }

    fetchContentEdit() {
        const id = this.element.data('id');
        const path = Routing.generate('app_estimation_setting.row.put', {"id": id});

        axios.get(path)
            .then(function(response){
                if (response.status === 200) {

                    console.log(response.data);

                    $('.pop-up').append(

                        '<div class="pop-up__box"><form>' +
                            '<div class="pop-up__content">' +
                            '<h2>' + Translator.trans('edit_mode.modal.row.edit_header', [], 'app') + '</h2>' +
                            '<label for="template_name">' + Translator.trans('edit_mode.modal.row.template_name', [], 'app') + '</label>' +
                            '<div class="input"><input type="text" id="template_name" value="' + response.data.template_name + '"></div>' +
                            '<label for="title">' + Translator.trans('edit_mode.tool_panel.row.title', [], 'app') + '</label>' +
                            '<div class="input"><input type="text" id="title" value="' + response.data.title + '"></div>' +
                            '<label for="subtitle">' + Translator.trans('edit_mode.tool_panel.row.subtitle', [], 'app') + '</label>' +
                            '<div class="input"><input type="text" id="subtitle" value="' + response.data.subtitle + '"></div>' +

                            '<div class="box-form__row -half">' +
                                '<div class="input">' +
                                    '<label for="rate_value">' + Translator.trans('edit_mode.tool_panel.row.amount', [], 'app') + '</label>' +
                                    '<div class="input__field"><input type="text" id="rate_value" value="' + response.data.rate_value + '"></div>' +
                                '</div>' +
                                '<div class="input">' +
                                    '<label for="rate_unit">' + Translator.trans('edit_mode.tool_panel.row.unit', [], 'app') + '</label>' +
                                    '<div class="input__field"><input type="text" id="rate_unit" value="' + response.data.rate_unit + '"></div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="box-form__row -half">' +
                                '<div class="input">' +
                                    '<label for="rate_currency">' + Translator.trans('edit_mode.tool_panel.row.currency', [], 'app') + '</label>' +
                                    '<div class="input__field"><input type="text" id="rate_currency" value="' + response.data.rate_currency + '"></div>' +
                                '</div>' +
                                '<div class="input box-form__input--discount">' +
                                    '<label for="discount">' + Translator.trans('edit_mode.tool_panel.row.row_discount', [], 'app') + '</label>' +
                                    '<div class="input__field"><input type="text" id="discount" value="' + response.data.rate_discount + '"></div>' +
                                    '<label class="flipswitch" title="Ustaw widoczność strony"><input id="active_discount" type="checkbox" class="flipswitch__check"' +
                                    discountIsActive(response.data.active_discount) + '/>' +
                                    '<div class="flipswitch__switch">' +
                                    '<div class="flipswitch__switch-button"></div>' +
                                    '</div>' +
                                    '<div class="flipswitch__msg">' +
                                    '<span class="flipswitch__msg__on">ON</span>' +
                                    '<span class="flipswitch__msg__off">OFF</span></div>' +
                                    '</label>' +
                                    '</div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="pop-up__buttons">' +
                        '<a class="btn-popup js-popup-close" href="#">' + Translator.trans('cancel', [], 'app') + '</a>' +
                        '<button class="btn-popup -primary js-popup-settings-save" type="submit">' + Translator.trans('save', [], 'app') + '</button>' +
                        '</div>' +
                        '</form></div>'
                    );

                    loader.hide();

                    $('.js-popup-settings-save').on('click', function(e) {
                        e.preventDefault();
                        popup.saveChanges();
                    })

                } else {
                    console.log('error');
                }

            }).then(
            this.showPopup()
        );

    }

    addNew() {
        const path = Routing.generate('app_estimation_setting.row.post');

        const row = {
            "active_discount": $('#active_discount').is(':checked'),
            "description": "",
            "rate_currency": $('#rate_currency').val(),
            "discount": $('#discount').val(),
            "rate_unit": $('#rate_unit').val(),
            "rate_value": $('#rate_value').val(),
            "subtitle": $('#subtitle').val(),
            "template_name": $('#template_name').val(),
            "title": $('#title').val(),
        };

        axios.post(path, row)
            .then(function(res){
                if (res.status === 200) {
                    refreshDatatable();
                } else {
                    toastr.error(Translator.trans('notification_modals.save_rate_template.error_text', [], 'app'));
                }

            });

        loader.show();

        this.hidePopup()

    }

    saveChanges() {
        const id = this.element.data('id');
        const path = Routing.generate('app_estimation_setting.row.put', {"id": id});

        const row = {
            "active_discount": $('#active_discount').is(':checked'),
            "rate_currency": $('#rate_currency').val(),
            "discount": $('#discount').val(),
            "rate_unit": $('#rate_unit').val(),
            "rate_value": $('#rate_value').val(),
            "subtitle": $('#subtitle').val(),
            "template_name": $('#template_name').val(),
            "title": $('#title').val(),
        };

        console.log(row);

        axios.put(path, row)
            .then(function(res){
                if (res.status === 200) {
                    refreshDatatable();
                } else {
                    toastr.error(Translator.trans('notification_modals.save_rate_template.error_text', [], 'app'));
                }

            });

        loader.show();

        this.hidePopup()

    }

    appendPopupHtml(value) {
        this.body.append(this.templatePopup);
        this.body.append(this.templateOverlay);

        if (value === 'edit') {
            this.fetchContentEdit();
        } else {
            this.fetchContent();
        }

        $(document).on('click', '.js-popup-close', (e: Object) => {
            e.preventDefault();
            this.hidePopup();
        });
    }

    init(value) {
        this.appendPopupHtml(value);
    }

}

function init() {
    $(document).on('click', '.js-popup-settings-row', function(e) {
        loader.show();
        popup = new Popup($(this));
        popup.init('edit');
        e.preventDefault();
    });

    $(document).on('click', '.js-popup-settings-row-new', function(e) {
        popup = new Popup($(this));
        popup.init();
        e.preventDefault();
    });
}

export { init };




// WEBPACK FOOTER //
// ./src/_app/estimation-settings/rows.js